import React, { useEffect } from 'react'
import { Col, Row, Input, Form, Button, Tooltip } from 'antd'
import commontStyles from '../../../Utils/Common.less'
import { SaveOutlined } from '@ant-design/icons'
import type {
    BankDetailsFormDataInterface,
    BankDetailsFormInterface,
} from '../../../Types/BankDetails'
import { BankDetailsItemDefaultData } from './bankingDetailsList'
import ActivePremission from '../../../Utils/premissins'
import { PermissionType } from '../../../Types/Enum/PermissionType'

const { TextArea } = Input

const BankingDetailsForm = (
    props: BankDetailsFormInterface
): React.ReactElement => {
    const { onSave, editData, isLoadingModal, resetdata, setResetData } = props
    const [form] = Form.useForm()
    useEffect(() => {
        form.setFieldValue('paymentOptionId', '0')
    }, [])
    useEffect(() => {
        form.setFieldsValue(editData)
    }, [editData])

    useEffect(() => {
        if (resetdata === 'true') {
            resetForm()
            form.resetFields()
        }
        setResetData('false')
    }, [resetdata])
    const resetForm = (): void => {
        form.setFieldsValue(BankDetailsItemDefaultData)
    }

    const customizeRequiredMark = (
        label: React.ReactNode,
        { required }: { required: boolean }
    ): React.ReactElement => (
        <>
            {label}
            &nbsp;
            {required && <span className={commontStyles.requireIcon}>*</span>}
        </>
    )

    return (
        <div className={commontStyles.formWrapper}>
            <Form
                name="complex-form"
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
                initialValues={{ remember: true }}
                layout={'vertical'}
                autoComplete="off"
                onFinish={(data) => {
                    onSave(data, resetForm)
                }}
                requiredMark={customizeRequiredMark}
                form={form}
            >
                <Form.Item<BankDetailsFormDataInterface>
                    name="paymentOptionId"
                    hidden={true}
                >
                    <Input />
                </Form.Item>
                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item<BankDetailsFormDataInterface>
                            label="Title"
                            name="paymentOptionTitle"
                            rules={[
                                {
                                    required: true,
                                    message: 'Please input your tittle!',
                                },
                            ]}
                        >
                            <Input />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item<BankDetailsFormDataInterface>
                            label="Account Name"
                            name="accountName"
                            rules={[
                                {
                                    required: true,
                                    message: 'Please input your account name!',
                                },
                            ]}
                        >
                            <Input />
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item<BankDetailsFormDataInterface>
                            label="Account No"
                            name="accountNo"
                            rules={[
                                {
                                    required: true,
                                    message:
                                        'Please input your account number!',
                                },
                            ]}
                        >
                            <Input />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item<BankDetailsFormDataInterface>
                            label="Branch"
                            name="branch"
                            rules={[
                                {
                                    required: true,
                                    message: 'Please input your branch!',
                                },
                            ]}
                        >
                            <Input />
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item<BankDetailsFormDataInterface>
                            label="Sort Code"
                            name="swiftCode"
                        >
                            <Input />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item<BankDetailsFormDataInterface>
                            label="IBAN"
                            name="iban"
                        >
                            <Input />
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item<BankDetailsFormDataInterface>
                            label="Description"
                            name="description"
                        >
                            <TextArea rows={4} />
                        </Form.Item>
                    </Col>
                </Row>
                {ActivePremission('1001', PermissionType.SAVE) && (
                    <Row gutter={16}>
                        <Col offset={21} span={2}>
                            <Tooltip title="Save">
                                <Button
                                    type="primary"
                                    htmlType="submit"
                                    loading={Boolean(isLoadingModal)}
                                >
                                    <SaveOutlined />
                                </Button>
                            </Tooltip>
                        </Col>
                    </Row>
                )}
            </Form>
        </div>
    )
}

export default BankingDetailsForm
